module.exports = __webpack_public_path__ + "img/iqiyi.4dcf7469.png";